// Source of truth for the Clinical Updates list shown on the Clinical Updates page.
// Also consumed by the Admin page to pick which guideline to send a notification email for.
// To add a new guideline: add an entry here (and its detail content in ClinicalUpdateDetailPage.jsx),
// then send the notification from Admin → Clinical Updates.
export const clinicalUpdates = [
    {
        id: "headache-management-ed",
        title: "Headache Management in the ED",
        organization: "American Headache Society",
        date: "Dec 2025",
        slug: "headache-management-ed"
    },
    {
        id: "early-management-acute-ischemic-stroke",
        title: "New Stroke Guidelines — Early Management of Acute Ischemic Stroke",
        organization: "American Heart Association/American Stroke Association",
        date: "Jan 2026",
        slug: "new-stroke-guidelines"
    },
    {
        id: "life-threatening-bleeds-itp",
        title: "Life threatening bleeds in ITP",
        organization: "McMaster ITP Emergency Management Guideline Group",
        date: "Feb 2026",
        slug: "life-threatening-bleeds-itp"
    },
    {
        id: "acute-pe-management",
        title: "Acute PE Management",
        organization: "American College of Cardiology/American Heart Association",
        date: "Feb 2026",
        slug: "acute-pe-management"
    },
    {
        id: "hepatic-encephalopathy",
        title: "Hepatic Encephalopathy",
        organization: "American College of Gastroenterology",
        date: "Mar 2026",
        slug: "hepatic-encephalopathy"
    },
    {
        id: "acute-low-back-pain",
        title: "Management of Acute Low Back Pain",
        organization: "Delphi",
        date: "May 2026",
        slug: "acute-low-back-pain"
    },
    {
        id: "pediatric-influenza",
        title: "Pediatric Influenza",
        organization: "American Academy of Pediatrics",
        date: "Aug 2026",
        slug: "pediatric-influenza"
    },
    {
        id: "streptococcal-pharyngitis",
        title: "Streptococcal Pharyngitis",
        organization: "Infectious Diseases Society of America",
        date: "Aug 2026",
        slug: "streptococcal-pharyngitis"
    },
    // Add more updates here as needed
];

export default clinicalUpdates;
